import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import {
  getDefaultApplicablePrepaidItem,
  getDefaultApplicablePrepaidPetItem,
  getDefaultDate,
  getDefaultSizeAlias,
  getDefaultStore,
} from "@utils/ipetbooking-get-default";

export default [
  // ===
  // 線上預約
  // ===
  {
    path: '/reservation',
    name: 'reservation',
    component: () => lazyLoadView(import('@views/Reservation/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['merchant/isSiteEnabled'])
          next({ name: '404' })

        try {
          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          const submitDate = {
            storeAlias: getDefaultStore(routeTo.query.store),
            date: getDefaultDate(routeTo.query.date),
            sizeAlias: getDefaultSizeAlias({
              queryIsUserMemberPet: routeTo.query.isUserMemberPet,
              queryPetId: routeTo.query.petId,
              querySize: routeTo.query.size,
              queryCategory: routeTo.query.category
            }),
            types: ['cosmetic']
          };

          const isNullSubmitDate = Object.values(submitDate)
            .some((value) => {
              return !value
            });

          if(isNullSubmitDate) {
            routeTo.params.reservationList = [];

            return next()
          }

          const [
            currentReservationList
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationList', submitDate),
          ]);

          routeTo.params.reservationList = currentReservationList.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
    props: (route) => ({
      pageType: 'reservation',
      reservationList: route.params.reservationList || []
    }),
  },
  // ===
  // 線上預約 內容頁
  // ===
  {
    path: '/reservation/:reservationAlias',
    name: 'reservation-item',
    component: () => lazyLoadView(import('@views/Reservation/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentReservationItem
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationItem', {
              reservationAlias: routeTo.params.reservationAlias,
              date: getDefaultDate(routeTo.query.date),
              prepaidOrderUuid: routeTo.query.prepaidId,
              types: ['cosmetic']
            })
          ]);

          routeTo.params.reservationItem = currentReservationItem.items;

          if(!store.getters['auth/isLoggedIn']) {
            return next()
          }

          await store.dispatch('order/fetchApplicablePrepaidOrderList', {
            useCached: true
          });

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
    props: (route) => ({
      reservationItem: route.params.reservationItem
    }),
  },
  // ===
  // 使用包套方案
  // ===
  {
    path: '/prepaid-reservation',
    name: 'prepaid-reservation',
    component: () => lazyLoadView(import('@views/Reservation/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['merchant/isSiteEnabled'])
          next({ name: '404' })
        try {
          await Promise.all([
            store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            }),
            store.dispatch('order/fetchApplicablePrepaidOrderList', {
              useCached: true
            })
          ]);

          const applicablePrepaidItem = getDefaultApplicablePrepaidItem(routeTo.query.prepaidId);
          
          const applicablePrepaidPetItem = getDefaultApplicablePrepaidPetItem({
            queryPerpaidId: routeTo.query.prepaidId,
            queryPetId: routeTo.query.petId
          });

          const sizeAlias = applicablePrepaidPetItem?.sizeAlias || '';
          const storeAlias = routeTo.query.storeAlias || applicablePrepaidItem?.store?.alias 
          if(!sizeAlias || !applicablePrepaidItem.id) {
            routeTo.params.reservationList = [];

            return next()
          }
          const [
            currentReservationList
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationList', {
              date: getDefaultDate(routeTo.query.date),
              sizeAlias,
              prepaidOrderUuid: applicablePrepaidItem.id,
              storeAlias,
              types: ['cosmetic']
            }),
          ]);

          routeTo.params.reservationList = currentReservationList.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      liffShowMenu: false,
    },
    props: (route) => ({
      pageType: 'prepaid-reservation',
      reservationList: route.params.reservationList || []
    }),
  },
]
